import React, { Component } from "react";
import ReactDOM from 'react-dom';
import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Alert,
    UncontrolledTooltip
} from "reactstrap";

import Registry from "../../Utils/Registry";
import Helpers from "../../Utils/Helpers";
import Variables from "../../Utils/Variables";

import OperationsOrdersCancelModal from "./Orders/CancelModal";
import OperationsOrdersOrderGasBlock from "./Order/GasBlock";
import {NotificationManager} from "react-notifications";
import { InvoiceV2Service } from "../../services";


class OperationsOrderDetails extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.loadOrder = this.loadOrder.bind(this);
        this.toggleActions = this.toggleActions.bind(this);
        this.handleDocClick = this.handleDocClick.bind(this);
        this.cancelCancelation = this.cancelCancelation.bind(this);
        this.handleDocClick = this.handleDocClick.bind(this);
        this.requireInvoice = this.requireInvoice.bind(this);
        this.onCancelAsked = this.onCancelAsked.bind(this);

        this.actions_button = null;
        this.actions = [];

        this.state = {
            cancel_toggled: false,
            actions_toggled: false,
            loading: false,
            error: false,
            success: false,
            order: this.props.order,
            invoiceV2: undefined,
            vehicles: {
                sp95: [],
                gasole: [],
                gnr: []
            }
        };
    }

    componentDidMount(){
        this.loadOrder();
    }

    componentWillMount() {
        document.addEventListener('click', this.handleDocClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocClick, false);
    }

    handleDocClick(e){
        if(this.actions_button && !ReactDOM.findDOMNode(this.actions_button).contains(e.target)) {
            if(this.state.actions_toggled)
                this.setState({actions_toggled: false});
        }
    }

    getInvoiceV2 = () => {
        const { order } = this.state;
        if(order.should_be_invoiced_with_refacto) {
            const LoadInvoice = ir => ir && ir.invoicedBy ? InvoiceV2Service.Get(ir.invoicedBy.number).then(i => [ir, i]) : Promise.resolve([ir, null]);
            InvoiceV2Service.GetOrderInvoiceRequest(order.id).then(LoadInvoice)
                .then(([_, invoiceV2]) => this.setState({ invoiceV2 }));
        }
    };

    loadOrder(){
        if(this.props.orderId){
            this.setState({
                loading: true,
                error: false
            });

            this.api.get("/orders/" + this.props.orderId + "?is_business=1")
                .then(results => {
                    let vehicles = {};

                    for(let v of results.order.vehicles){
                        if(!vehicles[v.gas_shorten])
                            vehicles[v.gas_shorten] = [];
                        vehicles[v.gas_shorten].push(v);
                    }

                    this.setState({
                        loading: false,
                        order: results.order,
                        vehicles: vehicles
                    }, this.getInvoiceV2);
                })
                .catch(error => {
                    console.log(error);
                    this.setState({
                        loading: false,
                        error: "Commande introuvable"
                    }, () => {
                        NotificationManager.error("Commande introuvable");
                    });
                });
        }
    }

    toggleActions(){
        this.setState({actions_toggled: !this.state.actions_toggled});
    }

    setActions(){
        this.actions = [];

        if(this.state.order.status === "delivered")
            this.actions.push({label: "Obtenir la facture", onclick: () => { this.requireInvoice(this.state.order); }});

        if(this.state.order.status !== "delivered" && this.state.order.status !== "processing" && !this.state.order.cancel_request_datetime)
            this.actions.push({label: "Annuler", onclick: () => { this.setState({cancel_toggled: true}); }});
    }

    cancelCancelation(){
        this.setState({cancel_toggled: false});
    }

    onCancelAsked(){
        this.setState({cancel_toggled: false}, () => {
            NotificationManager.info("Votre demande d'annulation à bien été transmise, elle sera traitée dans les plus brefs delais");
            setTimeout(() => {this.loadOrder()}, 5000);
        });
    }

    requireInvoice(){
        const { order, invoiceV2 } = this.state;
        if(order.should_be_invoiced_with_refacto)
            InvoiceV2Service.Download(invoiceV2.number);
        else {
            let url = "?invoices_numbers=" + this.state.order.invoice_number + "&user_id=" + this.state.order.business_id + "&is_business=1";
            this.api
                .download("/orders/invoices/download" + url, 'tankyou-facture-' + this.state.order.invoice_number+'.pdf')
                .catch(error => {
                    NotificationManager.error("Impossible de recuperer les factures");
                });
        }
    }

    render(){
        const { order, invoiceV2 } = this.state;

        if(!order)
            return "";

        console.log(this.state.order);
        
        let _status = this.state.order.status;
        let status = _status;
        let status_comment = "";
        if(_status && Variables.orders.status_label.hasOwnProperty(_status)){
            status = Variables.orders.status_label[_status].title;
            status_comment = Variables.orders.status_label[_status].subtitle;
        }

        this.setActions();

        const total = order.should_be_invoiced_with_refacto ? 
            (invoiceV2 ? invoiceV2.totalWithTaxes : undefined)
        : (order.amount_to_pay ? order.amount_to_pay.toFixed(2) : undefined);

        return (
            <Row>
                <Col xs="12" sm="12" lg="6" >

                    {
                        this.state.cancel_toggled ?
                            <OperationsOrdersCancelModal
                                order={this.state.order}
                                isOpen={this.state.cancel_toggled}
                                onRefuse={this.cancelCancelation}
                                onRequestMade={this.onCancelAsked}
                            />
                            :
                            ""
                    }

                    <Alert color="warning" isOpen={this.state.order.cancel_request_datetime !== null}>
                        Une demande d'annulation de la commande faite le
                        { " " + Helpers.formatDate(this.state.order.cancel_request_datetime, "DD/MM/YY") + " " }
                        est en cour de traitement
                    </Alert>

                    {
                        this.state.loading ?
                            <div className="center">
                                <i className="icon icon-loading animated spin infinite f-20"> </i>
                            </div>
                            :
                            (
                                this.state.error ?
                                ""
                                :
                                <Card>
                                    <CardHeader className="ty-order-header relative blue_dark">
                                        <div className="pad-l-15 pad-r-15 display-inline-block">
                                            { Helpers.formatDate(this.state.order.status === 'waiting' ? this.state.order.available_date_min : this.state.order.start_datetime, "DD/MM/YY") }
                                        </div>
                                        <div className="pad-l-15 display-inline-block">
                                            Commande n&deg; { this.state.order.shorten }
                                        </div>

                                        {
                                            this.actions.length ?
                                                <div className="ty-order-actions" ref={ref => {this.actions_button=ref;}}>
                                                    <div className="ty-order-actions-caret" onClick={this.toggleActions}>
                                                        <i className={"icon icon-chevron-" + (this.state.actions_toggled ? "up" : "down")} aria-hidden="true"> </i>
                                                    </div>
                                                </div>
                                                : ""
                                        }
                                        {
                                            this.actions.length && this.state.actions_toggled ?
                                                <ul className="ty-item-actions-list">
                                                    {
                                                        this.actions.map((action, i) => {
                                                            return <li
                                                                key={i}
                                                                className="ty-item-action"
                                                                onClick={action.onclick}>
                                                                { action.label }
                                                            </li>;
                                                        })
                                                    }
                                                </ul>
                                                :
                                                ""
                                        }
                                    </CardHeader>

                                    <CardBody className="card-body">
                                        <Row>
                                            <Col md="8" xs="12">
                                                <div className="bold text-uppercase blue_dark">Informations livraison</div>
                                                <div className="marg-t-10">
                                                    { this.state.order.business_name ? this.state.order.business_name + " par " : "" }
                                                    { this.state.order.customer_first_name + " " + this.state.order.customer_last_name }<br />
                                                    { this.state.order.location }<br />
                                                    {
                                                        this.state.order.status === 'waiting' ?
                                                            Helpers.formatDate(this.state.order.available_date_min, "DD/MM/YYYY [de] HH[h] [à] ") + Helpers.formatDate(this.state.order.available_date_max, "HH[h]")
                                                            :
                                                            Helpers.formatDate(this.state.order.start_datetime)
                                                    }
                                                    {
                                                        this.state.order.purchase_order !== null ?
                                                            <div className="marg-t-10">
                                                                <span className="purchase-order-value">
                                                                    Bon de commande : { this.state.order.purchase_order }
                                                                </span>
                                                            </div>
                                                            : ""
                                                    }
                                                </div>
                                            </Col>
                                            <Col md="4" xs="12" className="f-10 right">
                                                Command&eacute; le { Helpers.formatDate(this.state.order.created_at, "DD/MM/YY") }
                                            </Col>
                                        </Row>
                                        {
                                            this.state.order.meta_data ?
                                                <Row className="marg-t-20">
                                                    <Col md="12">
                                                        <div className="bold text-uppercase blue_dark">Informations compl&eacute;mentaires</div>
                                                        <div className="marg-t-10">
                                                            {
                                                                Object.keys(this.state.order.meta_data).map((k, i) => {
                                                                    return <div key={"order-add-info-" + i}>{k} : {this.state.order.meta_data[k]}</div>
                                                                })
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                                : ""
                                        }
                                        <Row className="marg-t-20">
                                            <Col md="12">
                                                <div className="bold text-uppercase blue_dark">Carburants</div>
                                                    {
                                                        this.state.order.gas && Object.values(this.state.order.gas).map((gas, i) => {
                                                            return (this.state.order.gas_needed.indexOf(gas.shorten) > -1  && this.state.vehicles[gas.shorten] && this.state.vehicles[gas.shorten].length ?
                                                                <OperationsOrdersOrderGasBlock
                                                                    key={"gas-"+i}
                                                                    name={gas.name}
                                                                    color={gas.color}
                                                                    unit={gas.unit}
                                                                    unit_price={gas.price_ttc}
                                                                    vehicles={this.state.vehicles[gas.shorten]}
                                                                    qty={gas.quantity_delivered}
                                                                />
                                                                :
                                                                null)

                                                        })
                                                    }
                                            </Col>
                                        </Row>
                                        {
                                            this.state.order.products.length ?
                                                <Row className="marg-t-20">
                                                    <Col md="12">
                                                        <div className="bold text-uppercase blue_dark">Produits additionnels</div>
                                                            {
                                                                this.state.order.products.map((p, i) => {
                                                                    return <div key={"prod-" + i} className="product-block pad-20 marg-t-10">
                                                                        <div>
                                                                            <p className="product-name">{ p.product_name }</p>
                                                                            {p.vehicle ? <p className="vehicle-info">{p.vehicle.description} [{p.vehicle.plate}]</p> : ""}
                                                                        </div>
                                                                        <div>
                                                                            <p className="price">{ p.qty }x { p.unit_price } &euro; TTC</p>
                                                                        </div>
                                                                    </div>;
                                                                })
                                                            }
                                                    </Col>
                                                </Row>
                                                : null
                                        }
                                    
                                        {
                                            this.state.order.commercial_gesture && this.state.order.commercial_gesture.designation ?
                                                <Row className="marg-t-20">
                                                    <Col md="12">
                                                        <div className="bold text-uppercase blue_dark">Remises</div>
                                                        <ul className="discount-block marg-t-10">
                                                            <li className="discount-line">
                                                                <div>{ this.state.order.commercial_gesture.designation }</div>
                                                                <div>-{ this.state.order.commercial_gesture.amount_ttc } &euro;</div>
                                                            </li>
                                                        </ul>
                                                    </Col>
                                                </Row>    
                                                : ""
                                        }
                                    </CardBody>

                                    <CardFooter className="ty-order-footer bg-white">
                                        {
                                            this.state.order.status !== "delivered" ?
                                                <div className="text-center f-25">
                                                    <div className="pink text-uppercase">{ status }</div>
                                                    <div className="f-14">{ status_comment }</div>
                                                </div>
                                                :
                                                <div className="pad-l-15 pad-r-15">
                                                    <table className="wp-100">
                                                        <tbody>
                                                            <tr className="f-15">
                                                                <td className="gray_dark text-uppercase bold">
                                                                    Frais de services
                                                                    { this.state.order.fees_type === 0 ?
                                                                        <span>
                                                                            <i id="fees_tooltip" className="icon-question marg-l-10 blue_dark blue-hover pointer" aria-hidden="true"> </i>
                                                                            <UncontrolledTooltip placement="right" target="fees_tooltip">
                                                                                { this.state.order.fee_per_vehicle } &euro; TTC / v&eacute;hicules
                                                                            </UncontrolledTooltip>
                                                                        </span>
                                                                        :
                                                                        ""
                                                                    }
                                                                </td>
                                                                <td className="text-right">{ this.state.order.fees.total_ttc.toFixed(2) } &euro; TTC</td>
                                                            </tr>

                                                            { 
                                                                total !== undefined ?
                                                                    <tr className="f-24">
                                                                        <td className="text-uppercase">Total</td>
                                                                        <td className="bold text-right">{ total } &euro; TTC</td>
                                                                    </tr> : null 
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                        }
                                    </CardFooter>
                                </Card>
                            )
                    }
                </Col>
            </Row>
        );
    }
}

OperationsOrderDetails.defaultProps = {
    orderId: false,
    order:{
        created_at: "",
        id: false,
        status: "",
        location: "",
        start_datetime: "",
        cancel_request_datetime: null,
        customer: {
            first_name: "",
            last_name: "",
            business: null
        },
        vehicles: [],
        products: []
    }
};

export default OperationsOrderDetails;



// WEBPACK FOOTER //
// ./src/components/Operations/Order.js